import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import VerifiedSignature from "../../../../img/documentsign.png";
import { BiLockAlt } from "react-icons/bi";
import Moment from "react-moment";
import { isHTMLIdentifier } from "../../../../utils/universalFunction";

const SignatureReviewAllField = ({
  Show,
  Hide,
  Title,
  signedAllButtonLoader,
  signatureStudySubjectFormReviewAllFieldDataEntry,
  remark,
  setRemark,
  password,
  setPassword,
  formFields,
  totalDataEntry,
  setSelectedFields,
  selectedFields,
  totalOptionId
}) => {
  const [selectAll, setSelectAll] = useState(false)
  const firstName = JSON.parse(localStorage.getItem("firstName"));
  const lastName = JSON.parse(localStorage.getItem("lastName"));
  const [checkbox, setCheckbox] = useState(false);
  const [signatureHash, setSignatureHash] = useState("");

  const handleCheckboxChange = (e, fieldId, uniqueName, name, label, value) => {
    const isChecked = e.target.checked;
    setSelectedFields(prev => {
      let updated;
      if (isChecked) {
        const alreadyExists = prev.some(item => item.uniqueName === uniqueName);
        if (!alreadyExists) {
          updated = [...prev, { fieldId, uniqueName, name, label, value }];
        } else {
          updated = prev;
        }
      } else {
        updated = prev.filter(item => item.uniqueName !== uniqueName);
      }

      if (!isChecked) {
        setSelectAll(false);
      }

      return updated;
    });
  };

  function generateRandomCode(length = 9) {
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let result = "";

    for (let i = 0; i < length; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    if (!result || result.length <= 6) return result;
    const start = result.slice(0, 3);
    const end = result.slice(-3);
    const masked = "*".repeat(result.length - 6);
    return start + masked + end;
  }

  useEffect(() => {
    setSelectedFields([])
    setSelectAll(false)
    setSignatureHash(generateRandomCode(18))
  }, [Show]);

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    if (isChecked) {
      const allSelectableFields = [];
      formFields?.forEach(checkFieldData => {
        const checkEntryStatus = totalDataEntry?.find(item => item.fieldId === checkFieldData?.id);
        const isVisible = (checkFieldData?.conditionalIds || []).every(id => totalOptionId?.includes(id));
        if (!isVisible) return;
        const getFieldValue = () => {
          if (checkFieldData?.type === "date") {
            return `${checkEntryStatus?.day ?? ''}${checkEntryStatus?.month ? `-${checkEntryStatus.month}` : ''}${checkEntryStatus?.year ? `-${checkEntryStatus.year}` : ''}`;
          } else if (checkFieldData?.type === "time") {
            return `${checkEntryStatus?.hour ?? ''}${checkEntryStatus?.minute ? `-${checkEntryStatus.minute}` : ''}${checkEntryStatus?.second ? `-${checkEntryStatus.second}` : ''} ${checkEntryStatus?.format ?? ''}`;
          } else if (checkFieldData?.type === "checkbox") {
            return (checkEntryStatus?.value || [])?.map(item => item.value)?.join(", ");
          } else {
            return checkEntryStatus?.value;
          }
        };
        const baseFieldDisabled = (checkEntryStatus?.reviewStatus === "yes") || (checkEntryStatus?.status !== "freezed") || (checkEntryStatus?.queryStatus === "open");
        if (!baseFieldDisabled) {
          allSelectableFields.push({
            fieldId: checkFieldData.id,
            uniqueName: checkFieldData.fieldName,
            name: checkFieldData.fieldName,
            label: checkFieldData.fieldLabel,
            value: getFieldValue()
          });
        }
        const optionalFields = [
          {
            key: "fieldUnit",
            labelKey: "fieldUnitLabel",
            nameKey: "fieldUnitName",
            reviewKey: "unitReviewStatus",
            statusKey: "unitStatus",
            queryKey: "unitQueryStatus",
            queryNotifyKey: "unitQueryNotifyStatus",
            valueKey: "unit"
          },
          {
            key: "customFieldRemark",
            labelKey: "customFieldRemarkLabel",
            nameKey: "customFieldRemarkName",
            reviewKey: "reviewValueRemarkStatus",
            statusKey: "valueRemarkStatus",
            queryKey: "queryValueRemarkStatus",
            queryNotifyKey: "queryNotifyValueRemarkStatus",
            valueKey: "valueRemark"
          },
          {
            key: "referenceRangeLowerLimit",
            labelKey: "referenceRangeLowerLimitLabel",
            nameKey: "referenceRangeLowerLimitName",
            reviewKey: "referenceRangeLowerLimitReviewStatus",
            statusKey: "referenceRangeLowerLimitStatus",
            queryKey: "referenceRangeLowerLimitQueryStatus",
            queryNotifyKey: "referenceRangeLowerLimitQueryNotifyStatus",
            valueKey: "referenceRangeLowerLimit"
          },
          {
            key: "referenceRangeUpperLimit",
            labelKey: "referenceRangeUpperLimitLabel",
            nameKey: "referenceRangeUpperLimitName",
            reviewKey: "referenceRangeUpperLimitReviewStatus",
            statusKey: "referenceRangeUpperLimitStatus",
            queryKey: "referenceRangeUpperLimitQueryStatus",
            queryNotifyKey: "referenceRangeUpperLimitQueryNotifyStatus",
            valueKey: "referenceRangeUpperLimit"
          },
          {
            key: "referenceRangeIndicator",
            labelKey: "referenceRangeIndicatorLabel",
            nameKey: "referenceRangeIndicatorName",
            reviewKey: "referenceRangeIndicatorReviewStatus",
            statusKey: "referenceRangeIndicatorStatus",
            queryKey: "referenceRangeIndicatorQueryStatus",
            queryNotifyKey: "referenceRangeIndicatorQueryNotifyStatus",
            valueKey: "referenceRangeIndicator"
          },
          {
            key: "clinicalSignificance",
            labelKey: "clinicalSignificanceLabel",
            nameKey: "clinicalSignificanceName",
            reviewKey: "clinicalSignificanceReviewStatus",
            statusKey: "clinicalSignificanceStatus",
            queryKey: "clinicalSignificanceQueryStatus",
            queryNotifyKey: "clinicalSignificanceQueryNotifyStatus",
            valueKey: "clinicalSignificance"
          },
          {
            key: "customRemark",
            labelKey: "customRemarkLabel",
            nameKey: "customRemarkName",
            reviewKey: "remarkReviewStatus",
            statusKey: "remarkStatus",
            queryKey: "remarkQueryStatus",
            queryNotifyKey: "remarkQueryNotifyStatus",
            valueKey: "remark"
          },
        ];
        optionalFields.forEach(field => {
          if (checkFieldData?.[field.key] === "yes") {
            const disabled = checkEntryStatus?.[field.reviewKey] === "yes"
              || checkEntryStatus?.[field.statusKey] !== "freezed"
              || checkEntryStatus?.[field.queryNotifyKey] === "open"
              || checkEntryStatus?.[field.queryKey] === "open";

            if (!disabled) {
              const uniqueName = `${checkFieldData?.fieldName}_${checkFieldData?.[field.nameKey]}`;
              allSelectableFields.push({
                fieldId: checkFieldData.id,
                uniqueName,
                name: checkFieldData?.[field.nameKey],
                label: checkFieldData?.[field.labelKey],
                value: checkEntryStatus?.[field.valueKey]
              });
            }
          }
        });
      });
      setSelectedFields(allSelectableFields);
    } else {
      setSelectedFields([]);
    }
  };

  const cleanLabel = (text) => {
    if (!text) return '';
    return text
      .replace(/&nbsp;/g, ' ')
      .replace(/<\/?[^>]+(>|$)/g, ' ');
  };

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: '700px' }}>
        <Offcanvas.Header closeButton >
          <Offcanvas.Title>
            {Title}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group style={{ textAlign: "justify", fontSize: 13 }} className="mb-1">
            <p className="br3 bg-primary-subtle p-2" style={{ borderRadius: 3 }}>
              You are required to provide a signature for this activity in order
              to fully complete it. This records that you are signing off theat
              you have taken, and completed this online review activity. This
              will resilt in the completion record being recorded in your review
              history.
            </p>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Check
              type="checkbox"
              label="Select All Field"
              name="fieldLabel"
              className="fw-bold"
              checked={selectAll}
              onChange={handleSelectAll}
            />
            {formFields?.map((checkFieldData, index) => {
              const checkEntryStatus = totalDataEntry?.find(item => item.fieldId === checkFieldData?.id);
              let fieldValue;
              if (checkFieldData?.type === "date") {
                fieldValue = `${checkEntryStatus?.day ?? ''}${checkEntryStatus?.month ? `-${checkEntryStatus.month}` : ''}${checkEntryStatus?.year ? `-${checkEntryStatus.year}` : ''}`;
              } else if (checkFieldData?.type === "time") {
                fieldValue = `${checkEntryStatus?.hour ?? ''}${checkEntryStatus?.minute ? `-${checkEntryStatus.minute}` : ''}${checkEntryStatus?.second ? `-${checkEntryStatus.second}` : ''} ${checkEntryStatus?.format ?? ''}`;
              } else if (checkFieldData?.type === "checkbox") {
                fieldValue = (checkEntryStatus?.value || [])?.map(item => item.value)?.join(", ");
              } else {
                fieldValue = checkEntryStatus?.value;
              }
              return (
                (checkFieldData?.conditionalIds || [])?.every(id => totalOptionId?.includes(id)) && (
                  <div key={index}>
                    <Form.Check
                      type="checkbox"
                      label={
                        <>
                          {isHTMLIdentifier(checkFieldData?.fieldLabel || "") ? (
                            <span
                              dangerouslySetInnerHTML={{
                                __html: checkFieldData?.fieldLabel,
                              }}
                            />
                          ) : (
                            checkFieldData?.fieldLabel
                          )}{" "}
                          ({checkFieldData?.fieldName})
                        </>
                      }
                      name="fieldLabel"
                      className="fw-bold"
                      disabled={(checkEntryStatus?.reviewStatus === "yes") || (checkEntryStatus?.status !== "freezed") || (checkEntryStatus?.queryStatus === "open")}
                      checked={selectedFields?.map(item => item.uniqueName)?.includes(checkFieldData?.fieldName)}
                      onChange={e => handleCheckboxChange(e, checkFieldData?.id, checkFieldData?.fieldName, checkFieldData?.fieldName, checkFieldData?.fieldLabel, fieldValue)}
                    />

                    {checkFieldData?.fieldUnit === "yes" && (
                      <Form.Check
                        type="checkbox"
                        className="ms-4 fw-bold"
                        label={`${cleanLabel(checkFieldData?.fieldUnitLabel)} (${checkFieldData?.fieldUnitName})`}
                        name="fieldUnitLabel"
                        disabled={(checkEntryStatus?.unitReviewStatus === "yes") || (checkEntryStatus?.unitStatus !== "freezed") || checkEntryStatus?.unitQueryStatus === "open"}
                        checked={selectedFields?.map(item => item.uniqueName)?.includes(`${checkFieldData?.fieldName}_${checkFieldData?.fieldUnitName}`)}
                        onChange={e => handleCheckboxChange(e, checkFieldData?.id, `${checkFieldData?.fieldName}_${checkFieldData?.fieldUnitName}`, checkFieldData?.fieldUnitName, checkFieldData?.fieldUnitLabel, checkEntryStatus?.unit)}
                      />
                    )}

                    {checkFieldData?.customFieldRemark === "yes" && (
                      <Form.Check
                        type="checkbox"
                        className="ms-4"
                        label={`${cleanLabel(checkFieldData?.customFieldRemarkLabel)} (${checkFieldData?.customFieldRemarkName})`}
                        name="customFieldRemarkLabel"
                        disabled={(checkEntryStatus?.reviewValueRemarkStatus === "yes") || (checkEntryStatus?.valueRemarkStatus !== "freezed") || checkEntryStatus?.queryValueRemarkStatus === "open"}
                        checked={selectedFields?.map(item => item.uniqueName)?.includes(`${checkFieldData?.fieldName}_${checkFieldData?.customFieldRemarkName}`)}
                        onChange={e => handleCheckboxChange(e, checkFieldData?.id, `${checkFieldData?.fieldName}_${checkFieldData?.customFieldRemarkName}`, checkFieldData?.customFieldRemarkName, checkFieldData?.customFieldRemarkLabel, checkEntryStatus?.valueRemark)}
                      />
                    )}

                    {checkFieldData?.referenceRangeLowerLimit === "yes" && (
                      <Form.Check
                        type="checkbox"
                        className="ms-4"
                        label={`${cleanLabel(checkFieldData?.referenceRangeLowerLimitLabel)} (${checkFieldData?.referenceRangeLowerLimitName})`}
                        name="referenceRangeLowerLimitLabel"
                        disabled={(checkEntryStatus?.referenceRangeLowerLimitReviewStatus === "yes") || (checkEntryStatus?.referenceRangeLowerLimitStatus !== "freezed") || checkEntryStatus?.referenceRangeLowerLimitQueryStatus === "open"}
                        checked={selectedFields?.map(item => item.uniqueName)?.includes(`${checkFieldData?.fieldName}_${checkFieldData?.referenceRangeLowerLimitName}`)}
                        onChange={e => handleCheckboxChange(e, checkFieldData?.id, `${checkFieldData?.fieldName}_${checkFieldData?.referenceRangeLowerLimitName}`, checkFieldData?.referenceRangeLowerLimitName, checkFieldData?.referenceRangeLowerLimitLabel, checkEntryStatus?.referenceRangeLowerLimit)}
                      />
                    )}

                    {checkFieldData?.referenceRangeUpperLimit === "yes" && (
                      <Form.Check
                        type="checkbox"
                        className="ms-4"
                        label={`${cleanLabel(checkFieldData?.referenceRangeUpperLimitLabel)} (${checkFieldData?.referenceRangeUpperLimitName})`}
                        name="referenceRangeUpperLimitLabel"
                        disabled={(checkEntryStatus?.referenceRangeUpperLimitReviewStatus === "yes") || (checkEntryStatus?.referenceRangeUpperLimitStatus !== "freezed") || checkEntryStatus?.referenceRangeUpperLimitQueryStatus === "open"}
                        checked={selectedFields?.map(item => item.uniqueName)?.includes(`${checkFieldData?.fieldName}_${checkFieldData?.referenceRangeUpperLimitName}`)}
                        onChange={e => handleCheckboxChange(e, checkFieldData?.id, `${checkFieldData?.fieldName}_${checkFieldData?.referenceRangeUpperLimitName}`, checkFieldData?.referenceRangeUpperLimitName, checkFieldData?.referenceRangeUpperLimitLabel, checkEntryStatus?.referenceRangeUpperLimit)}
                      />
                    )}

                    {checkFieldData?.referenceRangeIndicator === "yes" && (
                      <Form.Check
                        type="checkbox"
                        className="ms-4"
                        label={`${cleanLabel(checkFieldData?.referenceRangeIndicatorLabel)} (${checkFieldData?.referenceRangeIndicatorName})`}
                        name="referenceRangeIndicatorLabel"
                        disabled={(checkEntryStatus?.referenceRangeIndicatorReviewStatus === "yes") || (checkEntryStatus?.referenceRangeIndicatorStatus !== "freezed") || checkEntryStatus?.referenceRangeIndicatorQueryStatus === "open"}
                        checked={selectedFields?.map(item => item.uniqueName)?.includes(`${checkFieldData?.fieldName}_${checkFieldData?.referenceRangeIndicatorName}`)}
                        onChange={e => handleCheckboxChange(e, checkFieldData?.id, `${checkFieldData?.fieldName}_${checkFieldData?.referenceRangeIndicatorName}`, checkFieldData?.referenceRangeIndicatorName, checkFieldData?.referenceRangeIndicatorLabel, checkEntryStatus?.referenceRangeIndicator)}
                      />
                    )}

                    {checkFieldData?.clinicalSignificance === "yes" && (
                      <Form.Check
                        type="checkbox"
                        className="ms-4"
                        label={`${cleanLabel(checkFieldData?.clinicalSignificanceLabel)} (${checkFieldData?.clinicalSignificanceName})`}
                        name="clinicalSignificanceLabel"
                        disabled={(checkEntryStatus?.clinicalSignificanceReviewStatus === "yes") || (checkEntryStatus?.clinicalSignificanceStatus !== "freezed") || checkEntryStatus?.clinicalSignificanceQueryStatus === "open"}
                        checked={selectedFields?.map(item => item.uniqueName)?.includes(`${checkFieldData?.fieldName}_${checkFieldData?.clinicalSignificanceName}`)}
                        onChange={e => handleCheckboxChange(e, checkFieldData?.id, `${checkFieldData?.fieldName}_${checkFieldData?.clinicalSignificanceName}`, checkFieldData?.clinicalSignificanceName, checkFieldData?.clinicalSignificanceLabel, checkEntryStatus?.clinicalSignificance)}
                      />
                    )}

                    {checkFieldData?.customRemark === "yes" && (
                      <Form.Check
                        type="checkbox"
                        className="ms-4"
                        label={`${cleanLabel(checkFieldData?.customRemarkLabel)} (${checkFieldData?.customRemarkName})`}
                        name="customRemarkLabel"
                        disabled={(checkEntryStatus?.remarkReviewStatus === "yes") || (checkEntryStatus?.remarkStatus !== "freezed") || checkEntryStatus?.remarkQueryStatus === "open"}
                        checked={selectedFields?.map(item => item.uniqueName)?.includes(`${checkFieldData?.fieldName}_${checkFieldData?.customRemarkName}`)}
                        onChange={e => handleCheckboxChange(e, checkFieldData?.id, `${checkFieldData?.fieldName}_${checkFieldData?.customRemarkName}`, checkFieldData?.customRemarkName, checkFieldData?.customRemarkLabel, checkEntryStatus?.remark)}
                      />
                    )}
                  </div>
                )
              );
            })}
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold mb-1">
              Remark{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setRemark(e.target.value)}
              value={remark}
              className="br3"
              placeholder="Remark"
              as="textarea"
            />
          </Form.Group>
          <div className="p-3 border rounded bg-light lh-1 mb-2">
            <small className="fw-bold"><BiLockAlt /> Electronic Signature</small>
            <Form.Label className="d-block mt-2" style={{ fontSize: 10 }}>
              Per 21 CFR Part 11, re-enter your password to authorise this
              action.
            </Form.Label>
            <Form.Group className="mb-2">
              <Form.Label className="mb-1 fw-bold">Username</Form.Label>
              <Form.Control disabled value={`${firstName || ""} ${lastName || ""}`} type="text" placeholder="Enter username" />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label className="fw-bold mb-1">
                Password{" "}
                <abbr title="Required" className="text-danger">
                  *
                </abbr>
              </Form.Label>
              <Form.Control
                onChange={(e) => setPassword(e.target.value)}
                value={password}
                className="br3"
                placeholder="Password"
                type="password"
              />
            </Form.Group>
          </div>
          <div className="p-2 border rounded mb-2">
            <div
              className="border border-2 rounded-start border-success border-end-0 position-relative"
              style={{ maxWidth: "fit-content" }}
            >
              <div className="p-3">
                <div className="hstack gap-2">
                  <h6 className="m-0 fw-bold">
                    {firstName}
                    <br />
                    {lastName}
                  </h6>

                  <div>
                    <p
                      className="m-0"
                      style={{ fontSize: 9 }}
                    >
                      Digitally signed by
                      <br />
                      {firstName} {lastName || ""}
                    </p>

                    <p
                      className="m-0"
                      style={{ fontSize: 9 }}
                    >
                      Date:
                      <Moment
                        format="DD/MM/YYYY"
                        withTitle
                      >
                        {new Date()}
                      </Moment>
                      |
                      <br />
                      <Moment
                        format="HH:mm:ss"
                        withTitle
                      >
                        {new Date()}
                      </Moment>
                      - GMT+06:30
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="position-absolute bg-white w-100"
                style={{
                  top: -10,
                  left: 30,
                }}
              >
                <p className="fw-bold m-0 ps-1">
                  eSigned By:
                </p>
              </div>

              <div
                className="position-absolute bg-white w-100"
                style={{
                  bottom: -10,
                  left: 30,
                }}
              >
                <p className="fw-bold m-0 ps-1">
                  {signatureHash}
                </p>
              </div>

              <img
                className="position-absolute"
                style={{
                  top: 8,
                  left: 47,
                  pointerEvents: "none",
                  filter: "opacity(0.2)",
                  width: 70,
                }}
                src={VerifiedSignature}
                alt="Signed"
              />
            </div>
          </div>
          <Form.Check onChange={(e) => setCheckbox(!checkbox)} checked={checkbox} label="I confirm the attestation above and understand this signature is permanent and cannot be removed." />
        </Offcanvas.Body>
        <div className="text-end p-2 bg-light">
          <button
            disabled={!remark || selectedFields?.length === 0 || signedAllButtonLoader || !checkbox || !password}
            onClick={signatureStudySubjectFormReviewAllFieldDataEntry}
            className="updateProfile"
          >
            {signedAllButtonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Signing...
              </div>
            ) : (
              "Sign Field"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default SignatureReviewAllField;